export default __webpack_public_path__ + "static/media/img-0063-usa-premium-face.b705c279.png";